import { module } from 'modujs';
import modularLoad from '../utils/modularload';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.href = window.location.pathname

        this.load = new modularLoad({
            enterDelay: 500,
            transitions: {
                list: {
                    enterDelay: 800
                },
                projectDetails: {
                    enterDelay: 300
                },
                newsDetails: {
                    enterDelay: 300
                }
            }
        });

        this.load.on('loading', (transition, oldContainer) => {

            // Close modals
            requestAnimationFrame(() => {
                this.call('close', null, 'ModalMenu');
                this.call('close', null, 'ModalVideo');
                this.call('close', null, 'ModalPartner');
            })

            if (transition == 'list') {
                this.call('scrollTo', { target: oldContainer.parentNode, offset: -120, options: { duration: 500 } }, 'Scroll')                
            }

            if(transition == 'projectDetails') {
                this.call('toggle', null, 'ModalProject');
            }

            if(transition == 'newsDetails') {
                this.call('toggle', null, 'ModalNews');                
            }            
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            this.href = window.location.pathname
            this.previousTransition = transition            
        });

        this.load.on('ready', (transition, newContainer) => {
            if (['list'].includes(transition)) {
                this.call('update', null, 'Scroll')
            }   
            
            if(!['projectDetails','newsDetails'].includes(transition)) {
                this.call('updateBackTarget', window.location.pathname, 'ModalProject')
                this.call('updateBackTarget', window.location.pathname, 'ModalNews')
            }
        })
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }
}
